import { render } from "./ChecklistSlot.vue?vue&type=template&id=a20c5da4&scoped=true"
import script from "./ChecklistSlot.vue?vue&type=script&lang=js"
export * from "./ChecklistSlot.vue?vue&type=script&lang=js"

import "./ChecklistSlot.vue?vue&type=style&index=0&id=a20c5da4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20c5da4"]])

export default __exports__